import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import cn from "classnames";
import styles from "./CenterCreate.module.sass";
import { Link } from "react-router-dom";
import Icon from "../../components/Icon";

// Screens
import CenterInformations from "./CenterInformations";
import AddressInformations from "./AddressInformations";
import DirectorInformations from "./DirectorInformations";
import ContactInformations from "./ContactInformations";

// Services
import { createCenter } from "../../services/center.service";
import { showSuccess, showError } from "../../services/toast.service";

const CenterCreate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [centerData, setCenterData] = useState({});

  const handleCenterChange = (e) => {
    const { name, value } = e.target;
    setCenterData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSwitchChange = (name, value) => {
    setCenterData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDropdownChange = (name, value) => {
    // Extraire uniquement la valeur du dropdown si c'est un objet avec une propriété value
    let finalValue = value && typeof value === 'object' && value.value !== undefined ? value.value : value;
    
    // Convertir en nombre si c'est une valeur numérique (pour type_of_employer et specific_employer)
    if ((name === 'type_of_employer' || name === 'specific_employer') && !isNaN(Number(finalValue))) {
      finalValue = Number(finalValue);
    }
    
    console.log(`Dropdown change - ${name}:`, finalValue, typeof finalValue);
    setCenterData((prev) => ({ ...prev, [name]: finalValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    
    // Afficher les données pour déboguer
    console.log('Données envoyées à PocketBase:', centerData);

    try {
      await createCenter(centerData);
      showSuccess("Centre créé avec succès!");
      navigate("/admin/centers/");
    } catch (err) {
      const errorMessage =
        "Impossible de créer le centre: " +
        (err.message || "Veuillez vérifier les informations saisies.");
      showError(errorMessage);
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.container}>
        <Link className={cn("button-white", styles.button)} to="/admin/centers/">
          <Icon name="arrow-left" />
          Retour
        </Link>

        <div className={styles.background}>
          <img src="/images/content/bg-shop.jpg" alt="Background" />
        </div>

        <div className={styles.formContainer}>
          {error && <div className={styles.error}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <CenterInformations
              center={centerData}
              onCenterChange={handleCenterChange}
              onDropdownChange={handleDropdownChange}
              onSwitchChange={handleSwitchChange}
            />
            <AddressInformations
              center={centerData}
              onCenterChange={handleCenterChange}
            />
            <DirectorInformations
              center={centerData}
              onCenterChange={handleCenterChange}
              onDropdownChange={handleDropdownChange}
            />
            <ContactInformations
              center={centerData}
              onCenterChange={handleCenterChange}
              onDropdownChange={handleDropdownChange}
              loading={loading}
            />
      
          </form>
        </div>
      </div>
    </>
  );
};

export default CenterCreate;
